import {
  Context,
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useState,
} from "react";
import { User } from "@one-profile/core";

type AppContextProvider = {
  user: User;
  getAccessToken: () => Promise<string>;
};
type AppConfig = {
  isUserClt?: boolean;
  accountId?: string;
};

export type AppContext = AppContextProvider & {
  appConfig: AppConfig;
  setAppConfig: Dispatch<SetStateAction<AppConfig>>;
};

export const appContext: Context<AppContext> =
  createContext<AppContext>(undefined);

export function AppContextProvider(
  props: PropsWithChildren<AppContextProvider>
) {
  const [appConfig, setAppConfig] = useState<AppConfig>({});

  return (
    <appContext.Provider
      value={{
        user: props.user,
        getAccessToken: props.getAccessToken,
        appConfig,
        setAppConfig,
      }}
    >
      {props.children}
    </appContext.Provider>
  );
}
